import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import CaretLeftOutlinedSvg from "@ant-design/icons-svg/es/asn/CaretLeftOutlined";
import AntdIcon from "../components/AntdIcon";
var CaretLeftOutlined = function CaretLeftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CaretLeftOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  CaretLeftOutlined.displayName = 'CaretLeftOutlined';
}
export default /*#__PURE__*/React.forwardRef(CaretLeftOutlined);